// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content-scrollable {
  max-height: 80vh; /* Adjust the height as needed */
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/SignUpModal.css"],"names":[],"mappings":"AAAA;EACI,gBAAA,EAAA,gCAAA;EACA,gBAAA;AACJ","sourcesContent":[".modal-content-scrollable {\n    max-height: 80vh; /* Adjust the height as needed */\n    overflow-y: auto;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
